import React from 'react';
import { input, textarea, select } from '../../utils/designTokens';

/**
 * AgentFormStep1 - Basic Info Form (Title, Description, Category, Tags)
 */
const AgentFormStep1 = ({ formData, onChange, categories, errors }) => {
  return (
    <div className="space-y-6">
      {/* Title */}
      <div>
        <label className="block text-sm font-semibold mb-2 text-gray-900 dark:text-spooky-ghost-white" htmlFor="title">
          Agent Title *
        </label>
        <input
          type="text"
          id="title"
          name="title"
          value={formData.title}
          onChange={onChange}
          placeholder="e.g., Research Assistant, Code Reviewer"
          className={input}
          maxLength={255}
        />
        <div className="flex justify-between mt-1">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Give your agent a clear, descriptive name
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formData.title.length}/255
          </p>
        </div>
        {errors.title && (
          <p className="text-sm text-red-500 mt-1">{errors.title}</p>
        )}
      </div>

      {/* Description */}
      <div>
        <label className="block text-sm font-semibold mb-2 text-gray-900 dark:text-spooky-ghost-white" htmlFor="description">
          Description *
        </label>
        <textarea
          id="description"
          name="description"
          value={formData.description}
          onChange={onChange}
          placeholder="Describe what this agent does and how it helps users..."
          className={textarea}
          rows={4}
          maxLength={1000}
        />
        <div className="flex justify-between mt-1">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            Explain the agent's purpose and capabilities
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            {formData.description.length}/1000
          </p>
        </div>
        {errors.description && (
          <p className="text-sm text-red-500 mt-1">{errors.description}</p>
        )}
      </div>

      {/* Category */}
      <div>
        <label className="block text-sm font-semibold mb-2 text-gray-900 dark:text-spooky-ghost-white" htmlFor="category_id">
          Category *
        </label>
        <select
          id="category_id"
          name="category_id"
          value={formData.category_id}
          onChange={onChange}
          className={select}
        >
          <option value="">Select a category</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>
              {cat.icon} {cat.name}
            </option>
          ))}
        </select>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Choose the category that best fits your agent
        </p>
        {errors.category_id && (
          <p className="text-sm text-red-500 mt-1">{errors.category_id}</p>
        )}
      </div>

      {/* Tags */}
      <div>
        <label className="block text-sm font-semibold mb-2 text-gray-900 dark:text-spooky-ghost-white" htmlFor="tags">
          Tags
        </label>
        <input
          type="text"
          id="tags"
          name="tags"
          value={formData.tags}
          onChange={onChange}
          placeholder="research, automation, data-analysis"
          className={input}
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Separate tags with commas. Tags help users discover your agent.
        </p>
      </div>
    </div>
  );
};

export default AgentFormStep1;
